export default "__VITE_ASSET__B8KcMi7D__"